function Arc(bearerToken = null) {
	const baseURL = window.ARC_BASE;
	return {
		baseURL: baseURL,
		async read(module, action, params = {}) {
			let url = null
			if (Array.isArray(params)) {
				url = `${baseURL}${module}/${action}?${params.join("&")}`;
			} else {
				const old_queryParams = new URLSearchParams(params).toString();
				const queryParams = decodeURIComponent(old_queryParams);
				url = `${baseURL}${module}/${action}${queryParams ? `?${queryParams}` : ''}`;
			}
			try {
				const headers = {
					'Content-Type': 'application/json',
				};
				if (bearerToken) {
					headers['Authorization'] = `Bearer ${bearerToken}`;
				}
				const response = await fetch(url, {
					method: 'GET',
					headers: headers
				});

				if (!response.ok) {
					const errorData = await response.json();
					throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
				}

				return await response.json();
			} catch (error) {
				console.error("Arc.read error:", error);
				throw error;
			}
		},
		async write(module, action, data = {}, params = {}) {
			const queryParams = new URLSearchParams(params).toString();
			const url = `${baseURL}${module}/${action}${queryParams ? `?${queryParams}` : ''}`;

			try {
				const headers = {
					'Content-Type': 'application/json',
				};

				if (bearerToken) {
					headers['Authorization'] = `Bearer ${bearerToken}`;
				}

				const response = await fetch(url, {
					method: 'POST',
					headers: headers,
					body: JSON.stringify(data),
				});

				if (!response.ok) {
					const errorData = await response.json();
					throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
				}

				return await response.json();
			} catch (error) {
				console.error("Arc.call error:", error);
				throw error;
			}
		},
		async serviceCall(module, action, data = []) {
			return this.write('actions', 'call', {
				parameters: data
			}, {
				service: module,
				action: action,
			})
		}
	}
}
export default Arc;